import { type FC, useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { AppRoute } from '@common/app/routes';
import { StringXSmall } from '@components/Typography/Typography';
import { Avatar } from '@components/ui/Avatar/Avatar';
import { Container } from '@components/ui/Container/container';
import { useAppSelector } from '@redux/store';
import cn from 'classnames';

import { useCheckVIPstatus } from '@/common/hooks/checkVIPstatus';

import { IntroContext } from '../Intro/context';
import { ModalContext } from '../Modals/Modal/config';
import VipAvatar from '../ui/VipAvatar/VipAvatar';

import css from './styles.module.scss';

import defaultAvatar from '/img/avatar.jpg';

const UserLevel: FC = () => {
  const avatarLink = useAppSelector((state) => state.user.user?.photoUrl);
  const level = useAppSelector((state) => state.user.user?.level);
  const statusVIP = useCheckVIPstatus();
  const { acountRef } = useContext(IntroContext);
  const [checkSettings] = useState<boolean>(
    !!localStorage.getItem('checkSettings') || false,
  );
  const { closeModal } = useContext(ModalContext);

  // The chip is the only way to Settings (logout, account deletion), so it
  // stays even for an account the backend gave no photo
  return (
    level !== undefined && (
      <NavLink to={AppRoute.SETTINGS} onClick={() => closeModal()}>
        <Container
          ref={acountRef as React.Ref<HTMLDivElement>}
          variant="blur-10"
          className={cn('!w-auto flex items-center gap-2 pr-2 relative')}
          onClick={() => localStorage.setItem('checkSettings', 'true')}
        >
          <div className="relative">
            <div className={css.avatarWrapper}>
              <Avatar size={32} jpg={avatarLink || defaultAvatar} />
            </div>
            {statusVIP && <VipAvatar />}
          </div>
          <StringXSmall weight="bold">{`LVL ${level}`}</StringXSmall>
          {!checkSettings && (
            <div className="activeGreenPoint -top-[2%] -right-[2%]"></div>
          )}
        </Container>
      </NavLink>
    )
  );
};

export { UserLevel };
